import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SelectVariantProps } from "@/types/props/component";
import { SelectVariantEmits } from "@/types/emits/component";
import SelectBase from "@/components/selects/SelectBase.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectVariant',
  props: {
    modelValue: {},
    options: {},
    key: {},
    value: {},
    label: {}
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const changeVariant = (value: string) => {
    const newValue = props.options.find(option => option.variantId === value)

    if (!newValue) return emit('update:modelValue', props.modelValue)

    emit('update:modelValue', newValue)
    emit('change', newValue)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectBase, {
    "model-value": __props.modelValue.variantId,
    "onUpdate:modelValue": changeVariant,
    class: "grey1-grey1-color grey4-grey4-background",
    style: {"--original-background":"var(--ion-color-grey4)"},
    placeholder: _ctx.$t('placeholder.selectVariant'),
    "value-key": "variantId",
    "text-key": (option) => { return `${option.item.name} ${option.item.variants.name}` },
    options: __props.options
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('modal.selection')), 1)
    ]),
    _: 1
  }, 8, ["model-value", "placeholder", "text-key", "options"]))
}
}

})